import tableOperation from '../common/table-operation'

const getSearchedPhoneNumbers = function (state) {
  const { locationTwilio, table, phoneNumbers } = state
  const { searchText = '' } = table

  const matchFriendlyName = (currentPhoneNumber, value) => {
    const name =
      locationTwilio?.numberName[currentPhoneNumber?.phone_number] ||
      currentPhoneNumber?.friendly_name
    return name?.toLowerCase()?.includes(value?.toLowerCase())
  }

  const matchPhoneNumber = (currentPhoneNumber, value) =>
    currentPhoneNumber?.phone_number
      ?.toLowerCase()
      ?.includes(value?.toLowerCase())

  const searchedPhoneNumbers = tableOperation.applyClientSideFilter({
    searchQuery: searchText,
    filterConditions: [matchFriendlyName, matchPhoneNumber],
    collection: phoneNumbers,
  })

  return searchedPhoneNumbers
}

export default getSearchedPhoneNumbers
